import React from "react"
import FlexiblePage from "../../templates/flexible/template"

import PingPong from "@components/pingpong"

import { container } from "./styles.module.scss"

const TalentCommunity = () => {
  return (
    <>
      <FlexiblePage>
        <PingPong
          image={{
            alt: "Hand holding a mobile phone displaying Open Roles at Amperity",
            height: 700,
            src: "https://images.ctfassets.net/5vqt5w81x2im/3BrUOmWGejsJhIaQMGI9VI/11a3ec93b66e7e866c93846f2bca5855/Careers_TalentCommunity_Hero.jpg",
            width: 1080
          }}
          backgroundColor="off-black"
        >
          <h1>Join the Amperity Talent Community</h1>
          <p>Thanks for your interest. Please fill out the form below and we'll be in touch.</p>
        </PingPong>
        <div className={container}>
          <iframe
            title="talent-community-form"
            src="https://docs.google.com/forms/d/e/1FAIpQLScGTj7nNLk5fovbbM7TegPdZT8rudkj0VYTV-pz5xKHtbo9DQ/viewform?embedded=true"
            width="640"
            height="2009"
          >
            Loading…
          </iframe>
        </div>
      </FlexiblePage>
    </>
  )
}

export default TalentCommunity
